module.exports = __webpack_public_path__ + "img/contributionsFreeOn.42e5126e.svg";